import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import ConversationsList from '../components/chat/ConversationsList';
import DashboardLayout from '../components/layout/DashboardLayout';
import MessageService from '../services/message.service';

const PatientMessagesPage = () => {
  const [conversations, setConversations] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadConversations();
  }, []);

  const loadConversations = async () => {
    try {
      const data = await MessageService.getConversations();
      setConversations(data);
    } catch (error) {
      console.error('[DEBUG] Error loading conversations:', error);
    }
  };

  const handleSelectConversation = (id) => {
    navigate(`/patient/messagedetails/${id}`);
  };

  const handleConversationDeleted = (deletedId) => {
    setConversations(prevConversations =>
      prevConversations.filter(conv => conv.id !== deletedId)
    );
  };

  // Filtra le conversazioni in base al termine di ricerca
  const filteredConversations = conversations.filter(conv => {
    const fullName = `${conv.first_name} ${conv.last_name}`.toLowerCase();
    return fullName.includes(searchTerm.toLowerCase());
  });

  return (
    <DashboardLayout helpText="">
      <div className="h-full flex flex-col">
        <header className="bg-white p-4 shadow-sm">
          <h1 className="text-2xl font-bold mb-4">Messaggi</h1>
          <div className="relative">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Cerca nelle conversazioni..."
              className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <Search className="absolute left-3 top-2.5 text-gray-400 w-5 h-5" />
          </div>
        </header>
        <ConversationsList 
          conversations={filteredConversations}
          onSelectConversation={handleSelectConversation}
          onConversationDeleted={handleConversationDeleted}
          userRole="patient"
          nameField="doctor"
          specialtyField="specialization"
        />
      </div>
    </DashboardLayout>
  );
};

export default PatientMessagesPage;